<!--  -->
<template>
  <div>
    <section class="page-banner single-p-banner" style="background-image: url(/static/images/banner2.jpg);">
          <div class="container">
              <div class="row">
                  <div class="col-lg-7">
                      <a href="" class="post-cate" >{{course.spltip}}</a>
                      <h2 class="banner-title">
                          {{course.title}}
                      </h2>
                      <div class="bp-meta">
                           <router-link :to="`/views/${plateid}`">讲师：{{course.author}}</router-link>
                          <i :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></i>
                          <i :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></i>
                          <i :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></i>
                          <i :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></i>
                          <i :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></i>
                      </div>
                  </div>
              </div>
          </div>
    </section>  
    <section class="course-details-section">
      <div class="container">
          <div class="row">
              <div class="col-lg-9">
                  <div class="single-course-area">
                      <div class="course-top">
                          <h4>{{course.title}}</h4>
                          <div class="course-meta">
                              <div class="author">
                                  <img src="/static/images/home3/course/a1.png" alt="">
                                  <span>讲师:</span>
                                  <router-link :to="`/views/${plateid}`">{{course.author}}</router-link>
                              </div>
                              <div class="categories">
                                  <span>所属科目:</span>
                                  <a style="color:#6510AD !important;">{{course.type}}</a>
                              </div>
                              <div class="ratings">
                                  <span style="display: hide;">{{course.stars?parseFloat(course.stars).toFixed(1):'0'}} (评分)</span>
                                  <el-rate
                                    v-if="course.stars"
                                    disabled
                                    show-score
                                    :value="parseFloat(course.stars).toFixed(1)"
                                    text-color="#ff9900"
                                    :score-template="parseFloat(course.stars).toFixed(1)">
                                  </el-rate>
                                  <span v-else>暂无评分</span>
                              </div>
                          </div>
                          <div class="course-price" >
                              {{course.students?course.students:0}}人报名
                              <span>{{course.level}}</span>
                          </div>
                      </div>
                      <div class="sc-thumb" style="padding: 0px;">
                          <img :src="`${global.remoteIp}/uploads/${course.picsrc}`" :style="`width: 100%;height:${CourseImgHigh}`"  ref="CourseImg" alt="">
                      </div>
                      <div class="course-tab-wrapper">
                          <ul class="course-tab-btn nav nav-tabs">
                              <li><a href="#overview" data-toggle="tab"><i class="icon_ribbon_alt"></i>课程简介</a></li>
                              <li><a href="#curriculum" data-toggle="tab" class="active"><i class="icon_book_alt"></i>课程目录</a></li>
                              <!-- <li><a class="active" href="#instructors" data-toggle="tab"><i class="icon_profile"></i>Instructors</a></li> -->
                              <li><a href="#reviews" data-toggle="tab"><i class="icon_star"></i>课程评分</a></li>
                          </ul>
                          <!-- Tab Content -->
                          <div class="tab-content">
                              <!-- Overview Tab -->
                              <div class="tab-pane fade in" id="overview" role="tabpanel">
                                  <div class="overview-content" v-html="course.description">
                                  </div>
                              </div>
                              <!-- Overview Tab -->
                              <!-- Curriculum Tab -->
                              <div class="tab-pane fade in show active" id="curriculum" role="tabpanel">
                                  <div class="curriculum-item"   v-for="(Class,index) in course.classes" :key="index" :id="`id_${index+1}`">
                                      <div class="card-header" :id="`cc_${index+1}`">
                                          <h5 class="mb-0">
                                              <button class="btn btn-link" data-toggle="collapse" :data-target="`#acc_${index+1}`" :aria-expanded="index==0?'true':''" :aria-controls="`acc_${index}`">
                                                  {{Class.title}}
                                              </button>
                                          </h5>
                                      </div>
                                      <div :id="`acc_${index+1}`" class="collapse show" :aria-labelledby="`cc_${index+1}`" :data-parent="`#id_${index+1}`">
                                          <div class="card-body">
                                              <div   v-for="(video,indexex) in Class.videos" :key="indexex" :class="`ci-item ${indexex%2==0?'with-bg':''}`" @click="showVideo(video,indexex)">
                                                  <h5>
                                                      <i class="icon_menu-square_alt2"></i>
                                                      <a style="color: inherit !important;">{{video.info.title}}</a>
                                                  </h5>
                                                  <div class="ci-tools">
                                                      <a  class="time" style="color: inherit !important;">{{parseInt((parseFloat(video.info.time)*60)) }} 分钟</a>
                                                      <a  class="lock" style="color: inherit !important;"><i :class="course.isBuy==1?'icon_lock-open_alt':'icon_lock_alt'"></i></a>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="tab-pane fade in" id="reviews" role="tabpanel">
                                  <div class="reviw-area">
                                      <h4>学生评论</h4>
                                      <div class="reating-details">
                                          <div class="average-rate">
                                              <p>综合评分</p>
                                              <div class="rate-box">
                                                  <h2>{{course.stars?parseFloat(course.stars).toFixed(1):'0'}}</h2>
                                                  <div class="ratings">
                                                      <el-rate
                                                        v-if="course.stars"
                                                        disabled
                                                        :value="parseFloat(course.stars).toFixed(1)"
                                                        text-color="#ff9900"
                                                        :score-template="parseFloat(course.stars).toFixed(1)">
                                                      </el-rate>
                                                      <span v-else>暂无评分</span>
                                                  </div>
                                                  <span>{{intTotal}} 条评论</span>
                                              </div>
                                          </div>
                                          <div class="details-rate">
                                              <p>评分占比</p>
                                              <div class="detail-rate-box">
                                                  <div class="rate-item">
                                                      <p>5</p>
                                                      <div class="progress">
                                                          <div class="progress-bar" role="progressbar" :style="`width: ${StarRate['5']}%;`" aria-now="100" aria-valuemin="0" aria-valuemax="100"></div>
                                                      </div>
                                                      <span>{{StarRate['5']}}%</span>
                                                  </div>
                                                  <div class="rate-item">
                                                      <p>4</p>
                                                      <div class="progress">
                                                          <div class="progress-bar" role="progressbar" :style="`width: ${StarRate['4']}%;`" aria-valuenow="30" aria-valuemin="0" aria-valuemax="30"></div>
                                                      </div>
                                                      <span>{{StarRate['4']}}%</span>
                                                  </div>
                                                  <div class="rate-item">
                                                      <p>3</p>
                                                      <div class="progress">
                                                          <div class="progress-bar" role="progressbar" :style="`width: ${StarRate['3']}%;`" aria-valuenow="20" aria-valuemin="0" aria-valuemax="20"></div>
                                                      </div>
                                                      <span>{{StarRate['3']}}%</span>
                                                  </div>
                                                  <div class="rate-item">
                                                      <p>2</p>
                                                      <div class="progress">
                                                          <div class="progress-bar" role="progressbar" :style="`width: ${StarRate['2']}%;`" aria-valuenow="10" aria-valuemin="0" aria-valuemax="10"></div>
                                                      </div>
                                                      <span>{{StarRate['2']}}%</span>
                                                  </div>
                                                  <div class="rate-item">
                                                      <p>1</p>
                                                      <div class="progress">
                                                          <div class="progress-bar" role="progressbar" :style="`width: ${StarRate['1']}%;`" aria-valuenow="0" aria-valuemin="0" aria-valuemax="0"></div>
                                                      </div>
                                                      <span>{{StarRate['1']}}%</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="review-rating">
                                          <h5>评论列表</h5>
                                          <ol>
                                              <li  v-for="(comment, index) in comments" :key="index">
                                                  <div class="single-comment" >
                                                      <img :src="`/static/images/single-course/${comment.usersex=='女'?'r2.png':'r1.png'}`" alt="">
                                                      <h5><a style="color: #6510AD !important;">{{comment.username}}</a></h5>
                                                      <span>{{dateFormat(new Date(comment.createdAt),"yyyy-MM-dd hh:mm:ss")}}</span>
                                                      <div class="comment">
                                                          <p>
                                                            {{comment.comment}}
                                                          </p>
                                                      </div>
                                                      <div class="ratings">
                                                          <i class="icon_star"></i>
                                                          <i class="icon_star"></i>
                                                          <i class="icon_star"></i>
                                                          <i class="icon_star"></i>
                                                          <i class="icon_star"></i>
                                                      </div>
                                                      <div class="c-border"></div>
                                                  </div>
                                              </li>
                                          </ol>
                                          <el-pagination
                                              background
                                              :page-size="5"
                                              :hide-on-single-page="intTotal<=5"
                                              layout="prev, pager, next"
                                              @current-change="toPage"
                                              @prev-click="toPage"
                                              @next-click="toPage"
                                              :total="intTotal">
                                          </el-pagination>
                                      </div>
                                      <div class="review-form-area">
                                          <h5>添加评论</h5>
                                          <div class="comment-form">
                                              <div class="row">
                                                  <div class="col-md-12"  v-if="!isCourseStar">
                                                      <div class="comment-form-rating">
                                                          <label >评分:</label>
                                                          <div class="ratings" id="rating">
                                                              <el-rate v-model="commentStars"></el-rate>
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-12">
                                                      <textarea placeholder="请输入内容" v-model="commentMsg"></textarea>
                                                  </div>
                                                  <div class="col-md-12">
                                                      <button type="submit" @click="submitComment()">提交评论</button>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="related-course" v-if="!$root.onlymycourse">
                          <h3>推荐课程</h3>
                          <div class="related-course-slider owl-carousel">
                              <div class="feature-course-item-4" v-for="(course,index) in newCourse" :key="index">
                                  <div class="fcf-thumb">
                                      <img  :src="`${global.remoteIp}/uploads/${course.picsrc}`" :alt="course.title" style="height:204px">
                                      <a href="" class="enroll" >立即报名</a>
                                  </div>
                                  <div class="fci-details">
                                      <a href="" class="c-cate"><i class="icon_tag_alt">{{course.spltip}}</i></a>
                                      <h4><router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link></h4>
                                      <div class="author">
                                          <img src="/static/images/home3/course/a1.png" alt="">
                                          <a href="" >{{course.author}}</a>
                                      </div>
                                      <div class="price-rate">
                                          <div class="course-price">
                                              {{course.students?course.students:0}}人报名
                                              <!-- <span></span> -->
                                          </div>
                                          <div class="ratings">
                                              <i class="icon_star"></i>
                                              <span>{{course.stars?parseFloat(course.stars).toFixed(1):'0'}} (评分)</span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-3">
                <div class="course-sidebar">
                    <aside class="widget">
                        <div class="info-course">
                            <ul>
                                <li><i class="icon_house_alt"></i><span>讲师: </span> {{course.author}}</li>
                                <li><i class="icon_document_alt"></i><span>课时: </span> {{course.totalClass}}课</li>
                                <li><i class="icon_clock_alt"></i><span>时长: </span> {{course.totalTime}}小时</li>
                                <li><i class="icon_profile"></i><span>报名人数: </span> {{course.students}}</li>
                                <li><i class="icon_cog"></i><span>语言: </span> 中文</li>
                                <li><i class="icon_calendar"></i><span>上线时间: </span> {{dateFormat(new Date(course.createdAt),"yyyy-MM-dd")}}</li>
                                <li  style="color:red;" v-if="course.endtime"><i class="el-icon-alarm-clock"></i><span>到期时间: </span> {{course.endtime}}</li>
                            </ul>
                            <a href="javascript:;" class="bisylms-btn" :style="course.isBuy==1?'background-color: #949594;':''" type="button" @click="showTearch()">报名学习</a>
                        </div>
                    </aside>
                    <aside class="widget" v-if="!$root.onlymycourse">
                        <h3 class="widget-title">最新课程</h3>
                        <div class="latest-course"  v-for="(course,index) in newCourse" :key="index">
                            <router-link :to="`/courview/info/${course._id}`"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                            <h5><router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link></h5>
                            <div class="course-price">
                                讲师：{{course.author}}
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
          </div>
      </div>
    </section>

<el-dialog
    :title="`正在学习: ${video.title}`"
    :visible.sync="dialogVisible"
    :width="global.isPhone()? '95%':'50%'"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <el-divider></el-divider> 
    <div class="player-container" ref="VideoPlay" style="height:auto">
        <!-- <vue-core-video-player :autoplay="false"  :cover="`${global.remoteIp}/uploads/${video.picsrc}`" :src="`${global.remoteIp}/videoplay/${video.videosrc}?courseid=${course._id}`" :controls="auto"></vue-core-video-player> -->
        <!-- <LivePlayer :cover="`${global.remoteIp}/uploads/${video.picsrc}`"  :videoUrl="videoSrc" fluent autoplay hide-stretch-button></LivePlayer> -->
      <el-image v-if="video.isAudio"  :style="`width: 100%;height:${elImageHigh}`" :src="`${global.remoteIp}/uploads/${video.picsrc?video.picsrc:course.picsrc}`" ref="elImage"></el-image>
      <!-- <audio v-if="video.isAudio"
        style="width: 100%;"
        :src="videoSrc" controls="controls" controlsList="nodownload">
      Your browser does not support the audio element.
      </audio> -->
       <AudioPlayer  v-if="video.isAudio" style="width: 100%;" :audio-list="[videoSrc]" :show-prev-button="false" :show-next-button="false"/>
      <video-play v-else-if="videoSrc" :options="{url:videoSrc,videoId:video._id}" :style="`height:${videoHigh}`"/>
    </div>
</el-dialog>
<el-dialog
  :visible.sync="payInfoVisible"
  :width="global.isPhone()? '90%':'30%'"
  center
  >
  <el-descriptions title="订单信息" :column="1" border>
    <el-descriptions-item label="课程名称">{{payInfoCourse.title}}</el-descriptions-item>
    <el-descriptions-item label="课程讲师">{{payInfoCourse.author}}</el-descriptions-item>
    <el-descriptions-item label="课程科目">{{payInfoCourse.type}}</el-descriptions-item>
    <!-- <el-descriptions-item label="课程价格">{{payInfoCourse.price}}</el-descriptions-item> -->
  </el-descriptions>
  <span slot="footer" class="dialog-footer">
    <el-button @click="payInfoVisible = false; cancelPay()" >取 消</el-button>
    <!-- <el-button type="primary" @click="payInfoVisible = false;creatOrder()" >线上支付</el-button> -->
    <el-button type="primary" @click="payInfoVisible = false;showTearch()" >联系老师</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
// import LivePlayer from '@liveqing/liveplayer'
import VideoPlay from '../components/PublicComs/VideoPlay.vue';
import { Message } from "element-ui";
import jwt_decode from "jwt-decode";
export default {
  data() {
    return {
      course: {},
      subjects: [],
      newCourse: [],
      global,
      options: {
        i18n: {
          speed: "速度",
          normal: "正常",
        },
      },
      video: {},
      dialogVisible: false,
      payInfoCourse:{},
      payInfoVisible:false,
      videoSrc: "",
      videoHigh:0,
      commentMsg:"",
      comments: [],
      intTotal:0,
      commentStars:0,
      plateid:"",
      isCourseStar:false,
      StarRate:{
        '1': "0",
        '2': "0",
        '3': "0",
        '4': "0",
        '5': "0",
      },
      elImageHigh:"",
      CourseImgHigh:"",
      webConfig:{},
      userInfo:{},
      audioList:[],
    };
  },
  props: {
    plates: Array,
  },
  components: { VideoPlay },

  computed: {},

  mounted() {
    let courseId = this.$route.params.id;
    this.$axios.get(`/api/courses/visitor/${courseId}`).then((res) => {
      if (res.data) {
        this.course = res.data.data;
        this.isCourseStar = this.course.isCourseStar;
        if(this.course.isBuy==3)
        {
          this.$alert(`开课时间为${this.course.studystarttime}`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }else if(this.course.isBuy==4){
          this.$alert(`课程已结束`, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              
            }
          });
        }
        if (!this.course.addtime) {
          let addtime = this.course.createdAt;
          let date = new Date(addtime);
          this.course.addtime = `${date.getFullYear()}-${(
            "00" +
            (date.getMonth() + 1)
          ).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${(
            "00" + date.getHours()
          ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
            "00" + date.getSeconds()
          ).slice(-2)}`;
        }
        // this.course.stars = this.course.courseStarAvg[0].avgStar;
        let totalStars=0;
        for(let i =0 ; i < this.course.courseStarGroup.length;i++) {
          totalStars += this.course.courseStarGroup[i].count;
        }
        for(let i =0 ; i < this.course.courseStarGroup.length;i++) {
          let id= this.course.courseStarGroup[i]._id;
          this.StarRate[id.toString()] =((this.course.courseStarGroup[i].count/totalStars)*100).toFixed(2);
        }
        this.$nextTick(function(){
          this.CourseImgHigh = (this.$refs.CourseImg.clientWidth)*0.5625 + "px";
        })
      }
    });
    
     if(!this.$root.onlymycourse)
      {
          this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.newCourse = res.data.data;
        }
      });
     this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt&spltip[in]=评分最高,最受欢迎,销量最高")
      .then((res) => {
        if (res.data) {
          this.newCourse = res.data.data;
          this.$nextTick(function(){
            if ($(".related-course-slider").length > 0) {
              $('.related-course-slider').owlCarousel({
                  loop: false,
                  margin: 25,
                  responsiveClass: true,
                  dots: true,
                  autoplay: false,
                  smartSpeed: 700,
                  center: false,
                  nav: false,
                  items: 3,
                  responsive: {
                      0: {
                          items: 1
                      },
                      700: {
                          items: 2
                      },
                      1000: {
                          items: 3
                      }
                  }
              });
            }
          })
        }
      });
      }
    
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.subjects = res.data.data;
      }
    });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
     this.$axios.get("/api/auth/me").then(res => {
          const { token } = res.data;
          localStorage.setItem("eleTokenCustCysd001", token);
          // 解析token
          const decode = jwt_decode(token);
          // 存储数据
          this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
          this.$store.dispatch("setUser", decode);
           let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.$root.hasCourse =arrhasCourse;
          this.userInfo = res.data.data;
    })
    this.timer=setInterval(()=>{
        this.$axios.get("/api/auth/me").then(res => {
          const { token } = res.data;
          localStorage.setItem("eleTokenCustCysd001", token);
          // 解析token
          const decode = jwt_decode(token);
          // 存储数据
          this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
          this.$store.dispatch("setUser", decode);
           let arrhasCourse = [];
          for (var i = 0; i <res.data.data.needexaminee.length; i++)
          {
            arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
          }
          this.$root.hasCourse =arrhasCourse;
          this.userInfo = res.data.data;
        })
      },1000*60*10);
    this.$axios
      .get(`/api/courseComments/user?courseid=${courseId}&limit=5&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.comments = res.data.data;
          this.intTotal = res.data.total;
        }
      });
     this.$axios.get("/api/webConfigs").then(res => {
        if(res.data&&res.data.data.length>0)
        {
            this.webConfig = res.data.data[0];
        }
    }); 
  },

  methods: {
    toPage(intcount) {
       this.$axios
        .get(
          `/api/courseComments/user?page=${
            intcount
          }&limit=5&sort=-createdAt&courseid=${this.course._id}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.comments = res.data.data;
          }
        });
    },
    showVideo(video) {
      if(this.course.isBuy!=1) {
       var strTip = "该课程为未报名观看，是否立即报名学习?";
        if(this.course.isBuy==2)
        {
          strTip = "该课程已到期，是否重新报名学习?";
        }
        if(!video.isShiKan)
        {
          this.$alert(`此视频暂不支持试看`, '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        }else{
          this.$confirm(strTip, '提示', {
          confirmButtonText: '立即报名',
          cancelButtonText: '试看',
          type: 'warning'
        }).then(() => {
          this.showTearch();
        }).catch(() => {
           this.video = video.info;
            this.videoSrc=this.video.videosrc;
            this.dialogVisible = true;
            this.$nextTick(function(){
                this.videoHigh = (this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
                this.elImageHigh =(this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
              })  
        });
        }
        
      }else{
        this.video = video.info;
            //this.videoSrc=`${this.global.remoteIp}/videoplay/${this.video.videosrc}?courseid=${this.course._id}`
            this.videoSrc=this.video.videosrc;
            this.dialogVisible = true;
            this.$nextTick(function(){
                this.videoHigh = (this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
                this.elImageHigh =(this.$refs.VideoPlay.clientWidth)*0.5625 + "px";
              })  
      }
     
    },
    showTearch(){
      if(this.course.isBuy!=1) {
      this.$alert(`您可以联系${this.webConfig.contact}，联系电话：${this.webConfig.mobile}`, '报名方式', {
          confirmButtonText: '确定',
          callback: action => {
            this.$axios.post(`/api/userSignUps`,{
              userid:this.userInfo._id,
              username:this.userInfo.name,
              courseid:this.course._id,
              coursetype:this.course.type,
              coursename:this.course.title,
              teacherid:this.course.createuserid,
              teachername:this.course.createusername
            })
          }
        });
      }
    },
    handleClose() {
      this.videoSrc="";
      this.dialogVisible = false;
    },
    creatOrder(){
      const loading = this.$loading({
          lock: true,
          text: '正在创建订单，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.global.isPhone()?
      this.$axios.post(`/api/zfb/createOrder_m`,{
        payName:"购买在线课程",
        goodsName:"在线课程-"+this.course.title,
        count:1,
        goodsId:this.course._id,
        returnHtml:"<script> + window.open('" + this.global.remoteIp + "/courview/info/"+this.course._id+"','_self') <\/script>"
      }).then((res) => {
         // loading.close();
           const div=document.createElement('divform');
          div.innerHTML=res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
      }).catch((e) => {
        loading.close();
      })
      :
      this.$axios.post(`/api/zfb/createOrder_pc`,{
        payName:"购买在线课程",
        goodsName:"在线课程-"+this.course.title,
        count:1,
        goodsId:this.course._id,
        returnHtml:"<script> + window.open('" + this.global.remoteIp + "/courview/info/"+this.course._id+"','_self') <\/script>"
      }).then((res) => {
        //loading.close();
           const div=document.createElement('divform');
          div.innerHTML=res.data;
          document.body.appendChild(div);
          document.forms[0].submit();
      }).catch((e) => {
        loading.close();
      });
    },
    cancelPay(){
      this.payInfoCourse = {};
    },
    enterPay(){
      if(this.course.isBuy!=1&&this.course.price!=0)
      {
        this.$axios.get(`/api/zfb/payinfo/?_id=${this.course._id}`).then((res) => {
          this.payInfoCourse = res.data.data;
          this.payInfoVisible = true;
        });
      }
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    submitComment(){
      if(this.commentStars)
      {
        this.commitStars();
        this.commentStars = "";
      }
      if(!this.commentMsg)return;
      this.$axios.post(`/api/courseComments/user`,{
        courseid:this.course._id,
        comment: this.commentMsg
      }).then((res) => {
         if(res&&res.data){
           Message.success("评论成功");
           this.commentMsg="";
           this.toPage(0)
         }
      })
    },
    commitStars(){
       this.$axios.post(`/api/courseStars/user`,{
        courseid:this.course._id,
        stars: this.commentStars
      }).then((res) => {
         if(res&&res.data){
           Message.success("评分成功");
           this.isCourseStar = true;
         }
      })
    },
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    },
  },
};
</script>
<style scoped>
::v-deep .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 0px;
}
::v-deep .el-dialog__body {
  padding: 5px 20px 30px 20px;
}
::v-deep .el-dialog__title {
  color: #233d63;
  font-size: 29px;
  line-height: 33px;
  font-weight: 500;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
::v-deep .el-pager li.active {
  color: #51be78;
}
.la{
  color: #F68A03;
}
.la-globe{
  color: #F68A03;
}

audio::-webkit-media-controls {
  overflow: hidden !important
}
/* audio::-webkit-media-controls-enclosure {
    margin-left: auto;
} */
::v-deep .audio__play-rate{
  display: none;
}
::v-deep .audio__progress-point{
  display: none !important;
}
::v-deep .audio__play-icon{
  color: #000 !important;
}
::v-deep .audio__play-volume{
  background-color: #000 !important;
}
::v-deep ..audio-player .audio__progress-wrap{
  margin-top: 5px !important;
}

</style>
